export default __webpack_public_path__ + "static/media/notif2.9e82fa7a.wav";